// extracted by mini-css-extract-plugin
module.exports = {"container":"EntityNavigationGrid_container__yobpK","title":"EntityNavigationGrid_title__uYeO0","list":"EntityNavigationGrid_list__zMWNw"};